import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Loader from '../../utils/Loader';
import DailyStep from './dailystep.svg';
import moment from 'moment';
import { startAttempt } from '../../redux/testPage/testPage.actions';
import { getUpNext } from '../../redux/myCourse/myCourse.actions';
import UpnextList from './upnextList';
import { setErrorPanel } from '../../redux/utilities/utils.actions';
import PermitMicModal from '../common/permitMic';
import SubscribeForUpdates from '../common/subscribe';
import { setShowSubscribe } from '../../redux/profile/profile.actions';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import AddToHomeScreen from '../AddToHomeScreenBanner';
import { isInStandaloneMode, isIos } from '../../utils/commonFunctions';
import { resetToken } from '../../redux/parentDashboard/parentDashboard.actions';
import Carousel from 'react-bootstrap/Carousel';
import RecommendedList from '../common/recommendCourses';
import UserTypes from '../../utils/userTypes';

const userDetailsObj = JSON.parse(localStorage.getItem('userDetails'));

const MyDashboard = ({
	error: { panelClass, panelMsg },
	startAttempt,
	getUpNext,
	isRetail,
	setErrorPanel,
	isSubscribe,
	setShowSubscribe,
	resetToken,
	userType,
	childStatus,
	show_dailystep,
}) => {
	const [showUpdate, setUpdateProfile] = useState(false);
	const [showInstallMessage, setshowInstallMessage] = useState(false);
	let ignoreUpdateTime =
		localStorage.getItem('ignoreUpdateTime') !== null
			? moment(localStorage.getItem('ignoreUpdateTime'))
			: moment().subtract(1, 'day');
	const now = moment();

	useEffect(() => {
		if (userType === UserTypes.Parent || userType === UserTypes.Junior) {
			resetToken();
		}
	}, [userType, resetToken]);

	useEffect(() => {
		return () => {
			setErrorPanel({});
		};
	}, [setErrorPanel]);

	useEffect(() => {
		Loader.hide();

		let lastNotify =
			localStorage.getItem('lastNotify') !== null
				? moment(localStorage.getItem('lastNotify'))
				: moment().subtract(2, 'day');
		// Checks if should display install popup notification:

		if (isIos() && !isInStandaloneMode() && now.diff(lastNotify, 'days') >= 1) {
			setshowInstallMessage(true);
			localStorage.setItem('lastNotify', new Date());
		} else {
			localStorage.setItem('lastNotify', new Date());
		}
	}, [now]);

	useEffect(() => {
		getUpNext();
	}, [getUpNext]);

	useEffect(() => {
		if (isSubscribe === null) {
			setShowSubscribe(true);
		}
	}, [isSubscribe, setShowSubscribe]);

	useEffect(() => {
		setUpdateProfile(
			isRetail &&
			!!userDetailsObj &&
			!Object.values(userDetailsObj).every((x) => !!x && x !== 'null') &&
			now.diff(ignoreUpdateTime, 'days') > 0,
		);
	}, [isRetail, ignoreUpdateTime, now]);

	const toggleProfileBanner = () => {
		localStorage.setItem('ignoreUpdateTime', moment());
		setUpdateProfile(false);
	};

	return (
		<>
			{showUpdate && (
				<div className="update_popup">
					Do you want to update your profile?
					<a className="update-popup-btn" target="_self" href="/profile">
						Update
					</a>
					<div
						onClick={toggleProfileBanner}
						className="promo-slide-in-close-promo"
					></div>
				</div>
			)}
			<div className={panelClass}>
				<span dangerouslySetInnerHTML={{ __html: panelMsg }} />
			</div>

			<Carousel controls={childStatus} indicators={childStatus}>
				{!!childStatus && (
					<Carousel.Item interval={10000}>
						<div className="dashboard-banner dash-kids-banner">
							<div className="kids-banner-logo">
								<div className="hideInteraction"></div>
								<span className="speak-bubble speak-bubble-boy">Hi</span>
								<span className="speak-bubble speak-bubble-girl">Hello</span>
							</div>
							<div className="kids-banner-text">
								<p>
									You can now add child profiles to your account and get your child to
									take the free English assessment, STEPathon Junior (for Grades 3-10).
								</p>
								<a href="/parent/dashboard">
									<button aria-label="Start" className="btn btn-primary">
										Add Child Profiles
									</button>
								</a>
							</div>
						</div>
					</Carousel.Item>
				)}
				{isRetail && !!show_dailystep && (
					<Carousel.Item>
						<div className="daily-step-widget dash-courses">
							<div className="dash-course-logo">
								<img src={DailyStep} alt="Daily STEP" />
								<strong>Daily STEP</strong>
							</div>
							<div className="dash-course-decs">
								<p>Daily STEP is a demo course with English Learning task.</p>
								<div className="dash-course-decs-bottom">
									<button
										aria-label="Start"
										className="btn btn-primary"
										onClick={() => {
											startAttempt(0, 246);
										}}
									>
										Take the test
									</button>
									<p className="dash-decs-date">
										<strong>{moment(new Date()).format('D MMM yyyy')}</strong>
									</p>
								</div>
							</div>
						</div>
					</Carousel.Item>
				)}
			</Carousel>

			{showInstallMessage ? (
				<AddToHomeScreen
					message={
						<span>
							Install this web app on your device: tap{' '}
							<img alt="share" src="https://img.icons8.com/ios/50/000000/upload.png" />{' '}
							and then click Add to Home Screen{' '}
							<img
								src="https://img.icons8.com/ios/50/000000/plus-2-math.png"
								alt="Add"
							/>
						</span>
					}
				/>
			) : null}
			<UpnextList />
			<RecommendedList />
			<PermitMicModal />
			<SubscribeForUpdates />
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		elementId,
		courseId,
		title,
		getGrade,
		show_dailystep,
	} = state.rootReducer.myCourse;
	const {
		isOlympiad,
		newUser,
		isRetail,
		userType,
	} = state.rootReducer.loginDetails;
	const { isSubscribe, childStatus } = state.rootReducer.profileDetails;

	return {
		elementId,
		courseId,
		title,
		getGrade,
		isOlympiad,
		newUser,
		isRetail,
		error: state.rootReducer.utils.errorPanel,
		isSubscribe,
		userType,
		childStatus,
		show_dailystep,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		getUpNext: () => dispatch(getUpNext()),
		setErrorPanel: (msg) => dispatch(setErrorPanel(msg)),
		setShowSubscribe: (val) => dispatch(setShowSubscribe(val)),
		resetToken: () => dispatch(resetToken()),
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(MyDashboard),
);
